"use client";
import { useEffect, useState } from "react";
import { userService } from "@/services/user.service";
import { fetchWrapper } from "@/helpers/fetch-wrapper";

export function getUserData() {
	const [userData, setUserData] = useState(null);
	const [loading, setLoading] = useState(true);
	const [error, setError] = useState(null);

	useEffect(() => {
		const fetchUserData = async () => {
			try {
				const loggedIn = !!userService.userValue;

				if (loggedIn) {
					const response = await fetchWrapper.get('/api/users/getdata');
					setUserData(response[0]?.userData || null);
				} else {
					setUserData(null);
				}
			} catch (err) {
				setError(err);
				console.error("Failed to fetch user data:", err);
			} finally {
				setLoading(false);
			}
		};

		fetchUserData();
	}, []);

	return { userData, loading, error };
}
